import {Component} from '@angular/core';
import {Location} from '@angular/common';
import {LocalStorageService, UserService} from '../../_services';
import {ToastService} from '../../_services/toast.service';
import {LoadingService} from '../../_services/loading.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-why-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss']
})
export class FeedbackComponent {
  description = '';
  rating = -1;
  selectedProjectObj: any;
  userObj: any;


  constructor(private location: Location,
              private toast: ToastService,
              private localStorage: LocalStorageService,
              private spinner: LoadingService,
              public router: Router,
              private userService: UserService,) {
    this.selectedProjectObj = this.localStorage.get('selected_project');
    this.userObj = this.userService.currentUserValue;
  }

  calculateRating(index: number) {
    this.rating = index;
  }

  // @ts-ignore
  getStar(index: number) {
    if (Math.ceil(this.rating) === index && this.rating % 1 !== 0) {
      return 'star-half';
    } else if (this.rating >= index) {
      return 'star';
    } else {
      return 'star-outline';
    }
  }

  back() {
    this.router.navigate(['/map']);
  }

  sendFeedback() {

    this.spinner.show();
    const dataObj: any = {
      rating: this.rating,
      description: this.description,
      projectRef: this.selectedProjectObj.ref,
      userEmail: this.userObj === null ? '' : this.userObj.user.email
    };

    this.userService.addFeedback(dataObj)
      .subscribe((data) => {
        this.spinner.hide();
        this.toast.display('Feedback added successfully');
        this.router.navigate(['/map']);
      }, (error) => {
        this.toast.error('something went wrong');
        console.error(error);
      });
  }
}
